import React, { useContext } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { CustomizedTypography } from '@components/Customized';
import { HomeComponentContainer } from './styled';
import ReviewCard, { ReviewCardProps } from './Cards/ReviewCard';
import { MediaQuery } from '../HomePresenter';

const Reviews: React.FC = () => {
  const { container, textBox, cardBox } = useStyles();
  const { md, sm } = useContext(MediaQuery);

  return (
    <HomeComponentContainer
      className={container}
      padding={sm ? '100px 16px' : md ? '120px 36px' : '140px 0px'}
    >
      <Box className={textBox}>
        <CustomizedTypography
          variant={sm ? 'h2' : 'h1'}
          fontWeight="700"
          color="textPrimary"
        >
          고객의 생생한 경험담을
        </CustomizedTypography>
        <CustomizedTypography
          variant={sm ? 'h2' : 'h1'}
          fontWeight="700"
          color="textPrimary"
        >
          직접 들어보세요
        </CustomizedTypography>
      </Box>
      <Box className={cardBox}>
        {reviewContents.map((content, index) => (
          <ReviewCard {...content} key={content.companyName} />
        ))}
      </Box>
    </HomeComponentContainer>
  );
};

export default Reviews;

const reviewContents: ReviewCardProps[] = [
  {
    title: (
      <CustomizedTypography
        variant="body1"
        fontWeight="500"
        color="textPrimary"
      >
        전국의 업체들에게 견적을 받은 덕에 제조원가를 절감할 수 있었어요.
      </CustomizedTypography>
    ),
    companyName: '에스피엘',
    writer: 'CEO',
    review: (
      <CustomizedTypography variant="body2" color="textSecondary">
        “우연한 기회에 캐파를 알게 됐는데 전국에 있는 업체들로부터 다양한 견적을
        받아볼 수 있다는 점에 끌렸습니다. 덕분에 CNC 가공품의 제조원가를 절감할
        수 있었습니다. 도면 뷰어 시스템이 잘 갖춰져 있고 무엇보다 새로운 견적이
        올라오면 곧바로 휴대폰 문자메시지와 이메일로 알림을 받아볼 수 있어서
        신속하게 대응할 수 있는 점이 마음에 듭니다.”
      </CustomizedTypography>
    )
  },
  {
    title: (
      <CustomizedTypography
        variant="body1"
        fontWeight="500"
        color="textPrimary"
      >
        합리적인 가격의 업체를 <br />
        쉽게 접할 수 있어서 좋았습니다.
      </CustomizedTypography>
    ),
    companyName: '(주)아이에이치 코리아',
    review: (
      <CustomizedTypography variant="body2" color="textSecondary">
        “평소 새로운 제조업체를 물색해야 할 일이 많은데 캐파에서는 신규 업체를
        쉽게 만날 수 있어서 좋았습니다. 특히 개별적으로 가공업체를 찾으려면
        인터넷에서 검색하고 지도에서 위치도 확인해야 해서 번거로웠는데,
        캐파에서는 도면만 올리면 업체들이 먼저 연락을 해줬습니다. 별다른 수고
        없이도 합리적인 가격의 업체를 쉽게 접할 수 있어서 좋았습니다.”
      </CustomizedTypography>
    ),
    writer: '부장'
  },
  {
    title: (
      <CustomizedTypography
        variant="body1"
        fontWeight="500"
        color="textPrimary"
      >
        필요한 부품의 도면을 올리면
        <br /> 바로 견적을 받아 볼 수 있었습니다.
      </CustomizedTypography>
    ),
    companyName: 'MEMS',
    review: (
      <CustomizedTypography variant="body2" color="textSecondary">
        “자동화 장비를 직접 제조하다 보니 보통 여러 업체들로부터 부품을 조달해야
        합니다. 기존 업체가 폐업해 부품 확보에 어려움을 겪곤 했었는데,
        캐파에서는 필요한 부품의 도면을 올리면 곧바로 다양한 업체들로부터 견적을
        받아볼 수 있었습니다. 필요할 때마다 바로바로 대응이 가능한 캐파는 우리
        같은 업체한테 딱 맞는 서비스입니다.”
      </CustomizedTypography>
    ),
    writer: '연구과장'
  }
];

const useStyles = makeStyles((theme) => ({
  container: {
    gap: '56px',
    [theme.breakpoints.down('sm')]: {
      gap: '40px'
    }
  },
  textBox: {
    display: 'flex',
    flexDirection: 'column'
  },
  cardBox: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '24px',
    rowGap: '20px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
      gap: '16px'
    }
  }
}));
